var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransactionAttachment(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.387 20.291a4.92 4.92 0 01-3.504-1.451 4.96 4.96 0 010-7.007l5.66-5.66 1.078 1.079-5.66 5.66a3.435 3.435 0 000 4.85 3.407 3.407 0 002.426 1.005c.916 0 1.777-.357 2.425-1.005l5.925-5.925c.398-.396.616-.924.616-1.485s-.219-1.09-.616-1.486a2.105 2.105 0 00-2.968-.004l-5.659 5.66a.769.769 0 000 1.092c.301.3.79.3 1.092 0l5.66-5.66 1.077 1.078-5.659 5.66a2.298 2.298 0 01-3.92-1.625c0-.613.239-1.19.673-1.624l5.655-5.656a3.63 3.63 0 015.127 0 3.603 3.603 0 011.063 2.564c0 .969-.378 1.88-1.063 2.564L13.89 18.84a4.922 4.922 0 01-3.503 1.451z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionAttachment);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconTransactionAttachment.282f401b.svg";
export { MemoForwardRef as ReactComponent };